module.exports = __webpack_public_path__ + "img/img2.cc2b692c.png";